export class VerifyTwoFactorAuthModel {
    constructor() {
        this.passWord = "";
        this.verificationCode = "";
    }
}
export default class VerifyTwoFactorAuth extends VerifyTwoFactorAuthModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
